// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

// ** UseJWT import to get config
import useJwt from "@src/auth/jwt/useJwt";

import mixpanel from "mixpanel-browser";
import { MIXPANEL_USER_SESSION } from "../mixpanel/mixpanel_constants";

const config = useJwt.jwtConfig;

const initialUser = () => {
  const item = window.localStorage.getItem("userData");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {};
};

export const authSlice = createSlice({
  name: "authentication",
  initialState: {
    userData: initialUser(),
  },
  reducers: {
    handleLogin: (state, action) => {
      state.userData = action.payload;
      state[config.storageTokenKeyName] =
        action.payload[config.storageTokenKeyName];
      state[config.storageRefreshTokenKeyName] =
        action.payload[config.storageRefreshTokenKeyName];
      // console.log(state.config.storageRefreshTokenKeyName);
      // localStorage.setItem('userData', JSON.stringify(action.payload))
      // localStorage.setItem(config.storageTokenKeyName, JSON.stringify(action.payload.accessToken))
      // localStorage.setItem(config.storageRefreshTokenKeyName, JSON.stringify(action.payload.refreshToken))

      // Mixpanel Tracking
      const currentUser = action.payload;
      mixpanel.identify(currentUser._id);
      mixpanel.people.set({
        $email: currentUser.email,
      });
      mixpanel.track(MIXPANEL_USER_SESSION.USER_LOGIN);
    },
    handleLogout: (state) => {
      state.userData = {};
      state[config.storageTokenKeyName] = null;
      state[config.storageRefreshTokenKeyName] = null;
      // ** Remove user, accessToken & refreshToken from localStorage
      // localStorage.removeItem('userData')
      // localStorage.removeItem('userDetails')
      // localStorage.removeItem(config.storageTokenKeyName)
      // localStorage.removeItem(config.storageRefreshTokenKeyName)

      //Vyrill Storage
      Cookies.remove("bId");
      Cookies.remove("uId");
      Cookies.remove("jwt");
      localStorage.removeItem("session");
      localStorage.removeItem("vidUploadedInSession");
      localStorage.removeItem("toturialScreen");
      localStorage.removeItem("firstVideoAnalysisId");
      
      // Mixpanel Tracking
      mixpanel.track(MIXPANEL_USER_SESSION.USER_LOGOUT);
      mixpanel.reset();
    },
  },
});

export const { handleLogin, handleLogout } = authSlice.actions;

export default authSlice.reducer;
